import React, { useRef } from 'react'
import { useIntersection } from 'react-use'

import classnames from 'classnames'

import styles from '../../ProductListingPage.module.scss'

export const ProductListHeader = ({ children }) => {
  const intersectionRef = useRef(null)
  const intersection = useIntersection(intersectionRef, {
    threshold: 1,
  })

  return (
    <section
      data-testid="product-list-header"
      ref={intersectionRef}
      className={classnames(
        styles.productsListHeaderWrapper,
        intersection && intersection.boundingClientRect.top < 0 && styles.isSticky
      )}
    >
      <div className={styles.productsListHeader}>{children}</div>
    </section>
  )
}
